import {StyleSheet} from 'react-native';
import {Colors} from '../../../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    marginTop: 20,
    padding: 20,
    borderRadius: 10,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: Colors.lightGray,
    borderWidth: 1,
    borderColor: Colors.lightGray,
    minHeight: 109,
    gap: 15,
  },
  label: {
    fontSize: 13,
    fontFamily: 'TCCC-UnityText Bold',
    color: Colors.RedPallete.red,
  },
  ContainerData: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  dateText: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityText Regular',
    color: Colors.GrayPallete.lightgrayThree,
  },
});
